import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import ResourceSvc from '@/services/resource.svc.js';
import { DEFAULTS } from '../../constants/club-registration-constants.js';

const resourceService = new ResourceSvc();

export default {
    name: 'OfficerForm',
    
    components: {
        'text-answer': TextAnswer
    },

    props: {
        title: {
            type: String,
            required: true
        },
        idPrefix: {
            type: String,
            required: true
        },
        officer: {
            type: Object,
            required: true,
            default: () => ({ memberNo: '', name: '', email: '' })
        },
        memberNoLabel: {
            type: String,
            default: 'TI Member No.'
        },
        isMandatory: {
            type: Boolean,
            default: false
        },
        emailMandatory: {
            type: Boolean,
            default: false
        },
        memberNoValidation: {
            type: Boolean,
            default: false
        },
        nameValidation: {
            type: Boolean,
            default: true
        },
        emailValidation: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            memberNoValid: this.memberNoValidation,
            nameValid: this.nameValidation,
            emailValid: this.emailValidation,
            memberInfo: null,
            lookupLoading: false,
            lookupTimer: null
        };
    },

    computed: {
        localOfficer: {
            get() {
                return this.officer;
            },
            set(value) {
                this.$emit('update:officer', value);
            }
        },
        cmsUrl() {
            return process.env.url.manegement;
        }
    },

    methods: {
        lookupMember() {
            const memberNo = this.localOfficer.memberNo;
            if (!memberNo || String(memberNo).trim().length < 5) {
                this.memberInfo = null;
                return;
            }

            this.lookupLoading = true;
            const self = this;
            resourceService.getMemberByLoginOrTiID(String(memberNo).trim())
                .then(function (response) {
                    if (response && response.body && response.body.isSuccess && response.body.outputData) {
                        const data = response.body.outputData;
                        self.memberInfo = {
                            fullName: (data['First Name'] || '') + ' ' + (data['Last Name'] || ''),
                            email: data['Email'] || '',
                            tiNumber: data['TI Number'] || memberNo
                        };
                    } else {
                        self.memberInfo = null;
                    }
                })
                .catch(function () {
                    self.memberInfo = null;
                })
                .finally(function () {
                    self.lookupLoading = false;
                });
        },

        debouncedLookup() {
            if (this.lookupTimer) {
                clearTimeout(this.lookupTimer);
            }
            const self = this;
            this.lookupTimer = setTimeout(function () {
                self.lookupMember();
            }, 600);
        }
    },

    watch: {
        'localOfficer.memberNo': {
            handler(newVal) {
                this.$emit('update:officer', {
                    ...this.localOfficer,
                    memberNo: newVal
                });
                if (this.isAdmin) {
                    this.debouncedLookup();
                }
            }
        },
        'localOfficer.name': {
            handler(newVal) {
                this.$emit('update:officer', { ...this.localOfficer, name: newVal });
            }
        },
        'localOfficer.email': {
            handler(newVal) {
                this.$emit('update:officer', {
                    ...this.localOfficer,
                    email: newVal
                });
            }
        },
        memberNoValid(newVal) {
            this.$emit('update:memberNoValidation', newVal);
        },
        nameValid(newVal) {
            this.$emit('update:nameValidation', newVal);
        },
        emailValid(newVal) {
            this.$emit('update:emailValidation', newVal);
        }
    },

    mounted() {
        if (this.isAdmin && this.localOfficer.memberNo) {
            this.lookupMember();
        }
    },

    beforeDestroy() {
        if (this.lookupTimer) {
            clearTimeout(this.lookupTimer);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/components/officer-form/officer-form.js